import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {ProductDetailComponent} from '@entities/product/product-detail/product-detail.component';
import {ProductStorageHistoryDialogComponent} from '@entities/product/product-storage-history-dialog/product-storage-history-dialog.component';
import {ProductStorageDialogComponent} from '@entities/product/product-storage-dialog/product-storage-dialog.component';

@NgModule({
  declarations: [
    ProductDetailComponent,
    ProductStorageHistoryDialogComponent,
    ProductStorageDialogComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class ProductModule {}
